var map = {
	"./race_track_bg.png": 3977,
	"./race_track_bg_continental.png": 1983,
	"./race_track_bg_global.png": 9195,
	"./race_track_bg_regional.png": 3513,
	"./race_track_bg_saucer.png": 931,
	"./race_track_bg_transcontinental.png": 171,
	"./race_track_continental.png": 5985,
	"./race_track_global.png": 9209,
	"./race_track_regional.png": 1971,
	"./race_track_saucer.png": 3297,
	"./race_track_transcontinental.png": 3741
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2143;